import { combineReducers } from "redux";
import globalReducer from "./globalReducer";
import mentorReducer from "./mentorReducer";

const rootReducer = combineReducers({
  globalReducer,
  mentorReducer,
});
export default rootReducer;
